<template>
  <el-dialog
    :title="dialogTitle"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    destroy-on-close
    :visible="visible"
    @close="handleClose"
  >
    <el-form v-if="customer" size="mini">
      <el-row :gutter="15">
        <el-col :span="12">
          <el-form-item label="Teléfono">
            <el-input v-model="customer.phone" @change="handleChangePhone()" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Nombre">
            <el-input v-model="customer.name" @change="handleChangeName()" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="Notas" disabled>
        <el-input
          v-model="customer.notes"
          type="textarea"
          :rows="12"
          @change="handleChangeNotes()"
        />
      </el-form-item>
      <div class="text-right">
        <el-button v-if="isOnCall" size="mini" type="primary" @click="handleCloseAndHangup"
          >Cerrar y colgar</el-button
        >
        <el-button v-if="isOnCall" size="mini" type="primary" @click="handleCloseAndHold"
          >Cerrar y poner en espera</el-button
        >
        <el-button v-if="isOnCall" size="mini" type="primary" @click="handleCloseAndForward"
          >Cerrar y aparcar para desviar</el-button
        >
        <el-button size="mini" type="primary" @click="handleClose">Cerrar</el-button>
      </div>
    </el-form>
    <div v-else class="text-center flex flex-col gap py-5">
      <el-spinner />
    </div>
  </el-dialog>
</template>

<script>
import { getCustomerByPhone, patchCustomerById } from "@/api/operations/customers.ts";
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    visible: Boolean,
    data: Object,
    wgId: Number,
  },
  data() {
    return {
      customer: null,
    };
  },
  computed: {
    ...mapGetters("pbxCalls", ["isOnCall"]),
    dialogTitle() {
      if (this.customer) {
        return `Atendiendo servicio de ${this.data?.serviceProvided} para el número ${this.data?.callerNumber}`;
      }
      return "Cargando cliente...";
    },
  },
  watch: {
    visible(visibleNow, visibleBefore) {
      if (visibleNow && !visibleBefore) {
        this.loadCustomer(this.call?.callerNumber);
      }
    },
  },
  methods: {
    ...mapActions("pbxCalls", ["hangUp", "holdCall", "queueTransfer"]),
    ...mapActions("app", ["deleteAnsweredCall"]),
    async handleCloseAndHold() {
      await this.deleteAnsweredCall(this.data.asteriskId);
      await this.holdCall(this.data.asteriskId);
      this.handleClose();
    },
    async handleCloseAndForward() {
      await this.queueTransfer(this.data.asteriskId);
      await this.deleteAnsweredCall(this.data.asteriskId);
      this.handleClose();
    },
    async handleCloseAndHangup() {
      await this.hangUp({ asteriskId: this.data.asteriskId });
      this.handleClose();
    },
    handleClose() {
      this.customer = false;
      this.$emit("close");
    },
    async handleChangeName() {
      try {
        await patchCustomerById(this.wgId, this.customer.id, {
          name: this.customer.name,
        });
        this.$message({ type: "success", message: "Cambios guardados" });
      } catch (e) {
        this.$message({
          type: "error",
          message: "Ha ocurrido un problema guardando los datos",
        });
        console.error(e);
      }
    },
    async handleChangePhone() {
      try {
        await patchCustomerById(this.wgId, this.customer.id, {
          phone: this.customer.phone,
        });
        this.$message({ type: "success", message: "Cambios guardados" });
      } catch (e) {
        this.$message({
          type: "error",
          message: "Ha ocurrido un problema guardando los datos",
        });
        console.error(e);
      }
    },
    async handleChangeNotes() {
      try {
        await patchCustomerById(this.wgId, this.customer.id, {
          notes: this.customer.notes,
        });
        this.$message({ type: "success", message: "Cambios guardados" });
      } catch (e) {
        this.$message({
          type: "error",
          message: "Ha ocurrido un problema guardando los datos",
        });
        console.error(e);
      }
    },
    async loadCustomer() {
      this.customer = await getCustomerByPhone(this.wgId, this.data?.callerNumber);
    },
  },
};
</script>
